import useModal from "@/@core/components/base-modal/hooks/useModal";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import inventoryPrivilegeFormModel from "@/models/inventory/inventory-privilege-form";
import privilegeListModel from "@/models/privilege/privilege-list";
import router from "@/router";
import store from "@/store";
import useReorderTable from "@/views/components/base-table/hooks/useReorderTable";
import useBaseTable from "@/views/components/base-table/hooks/useBaseTable";
import { onBeforeMount, reactive, ref, watch } from "@vue/composition-api";

import usePermissionByAccount from "@/constants/navigation/BOYNYKJMS2EH/permission-by-account"

export default function usePrivilegeList() {
  const { getPermissionModule } = usePermissionByAccount()
  const { openModal, closeModal } = useModal();

  const {
    openDefaultErrorModal,
    openErrorModal,
    openWarningModal,
  } = useValidationModal();

  const {
    fetchPrivilegeListModel,
    reorderPrivilegeListModel,
    fetchPrivilegeCopy,
    fetchPrivilegeDelete,
  } = privilegeListModel();

  const { fetchAssignEntryInventory } = inventoryPrivilegeFormModel();

  const {
    filters,
    ordering,
    loading,
    pagination,
    fields,
    tableData: privilegeTable,
    actionTable,
    onPageChange,
    onFilterEntity,
    onSetValueSearch,
    onSelectFilter,
  } = useBaseTable();

  const {
    sortableRowOptions,
    currentIdSelect,
    currentIndex,
    keyChange,
    tableModeReorder,
  } = useReorderTable();

  const privilegeSelect = ref(null);

  fields.value = [
    { key: "seq", label: "No." },
    { key: "image_url", label: "Image" },
    { key: "name_en", label: "Name (En)" },
    { key: "name_th", label: "Name (Th)" },
    { key: "type_desc", label: "Privilege Type" },
    { key: "category", label: "Category" },
    { key: "alt_reference", label: "Reference" },
    { key: "status", label: "Status" },
    { key: "actions", label: "" },
  ];

  const formStatus = reactive({
    validFrom: null,
    validThrough: null,
    status: null,
  });

  const privilegeActionList = reactive({
    edit: {
      label: "Edit",
      value: 1,
      icon: "EditIcon",
      display: true,
    },
    copy: {
      label: "Copy",
      value: 2,
      icon: "CopyIcon",
      display: true,
    },
    // History: {
    //   label: 'History',
    //   value: 3,
    //   icon: 'IconHistory',
    //   display: true,
    // },
    assignInventory: {
      label: "Assign Inventory",
      value: 4,
      icon: "AssignBannerGroupIcon",
      display: true,
    },
    mappingCategory: {
      label: "Mapping Category",
      value: 5,
      icon: "MappingToIcon",
      display: true,
    },
    reOrder: {
      label: "Reorder",
      value: 6,
      icon: "ReorderIcon",
      display: false,
    },
    delete: {
      label: "Delete",
      value: 7,
      icon: "DeleteIcon",
      display: true,
    },
  });

  const statusOption = ref([
    { label: "Active", value: 1 },
    { label: "Inactive", value: 2 },
  ]);

  const modalType = reactive({
    reorder: false,
    assignInventory: false,
    mappingCategory: false,
  });

  const resolveMappingTableAction = (type, item) => {
    switch (type) {
      case 1:
        setDefaultActiveTab();
        router.push(`/privilege/info/${item.item.privilege_id}`);
        return;
      case 2:
        clonePrivilege(item.item);
        return;
      case 3:
        router.push(`/privilege/history/${item.item.privilege_id}`);
        return;
      case 4:
        privilegeSelect.value = item.item;
        modalType.assignInventory = true;
        openModal();
        return;
      case 5:
        privilegeSelect.value = item.item;
        modalType.mappingCategory = true;
        openModal();
        return;
      case 6:
        modalType.reorder = true;
        openReorderModal(item.item);
        return;
      case 7:
        deletePrivilege(item.item);
      default:
    }
  };
  
  const modalPopup = reactive({
    report: false,
  });

  const onOpenExportModal = () => {
    modalPopup.report = true;
    openModal();
  };

  const closeReportModal = () => {
    modalPopup.report = false;
    closeModal();
  };
  const onCloseModalPrivilege = () => {
    actionTable.fetchPayload(false);
    closeModal();
    setTimeout(() => {
      modalType.reorder = false;
      modalType.assignInventory = false;
      modalType.mappingCategory = false;
    }, 500);
  };

  // Reorder
  const onClickReorder = () => {
    privilegeActionList.reOrder.display = !privilegeActionList.reOrder.display;
    tableModeReorder.value = !tableModeReorder.value;
    sortableRowOptions.value.disabled = !sortableRowOptions.value.disabled;
  };

  const fetchReorderList = (id, currentPosition, newPosition) => {
    loading.tableOverlay = true;
    reorderPrivilegeListModel.payload.Privilege_Id = id;
    reorderPrivilegeListModel.payload.From = currentPosition;
    reorderPrivilegeListModel.payload.To = newPosition;
    store
      .dispatch("api/apiRequest", reorderPrivilegeListModel)
      .then((response) => {
        actionTable.fetchPayload(false);
      })
      .catch((error) => {
        openDefaultErrorModal(error);
        loading.tableOverlay = false;
      });
  };

  sortableRowOptions.value.onEnd = (event) => {
    fetchReorderList(
      privilegeTable.payload[event.oldDraggableIndex].privilege_id,
      privilegeTable.payload[event.oldDraggableIndex].seq,
      privilegeTable.payload[event.newDraggableIndex].seq
    );
    privilegeTable.payload.splice(
      event.newDraggableIndex,
      0,
      privilegeTable.payload.splice(event.oldDraggableIndex, 1)[0]
    );
    keyChange.value++;
  };

  const openReorderModal = (item) => {
    currentIndex.value = item.seq;
    currentIdSelect.value = item.privilege_id;
    openModal();
  };

  const reorderPrivilege = async (current, newIndex) => {
    fetchReorderList(currentIdSelect.value, currentIndex.value, newIndex);

    keyChange.value++;
    onCloseModalPrivilege();
  };
  // End Reorder

  const resolveStatusLabel = (status) => {
    switch (status) {
      case 1:
        return "Active";
      case 2:
        return "Inactive";
      default:
        return "Unknown";
    }
  };

  const resolveStatusClass = (status) => {
    switch (status) {
      case 1:
        return "active-icon";
      case 2:
        return "inActive-icon";
      default:
        return "Unknown";
    }
  };

  const clonePrivilege = (privilege) => {
    openWarningModal(
      "Copy Privilege",
      `ต้องการคัดลอก ${privilege.name_th} ใช่หรือไม่`,
      () => {
        loading.tableData = true;
        fetchPrivilegeCopy.payload.Privilege_Id = privilege.privilege_id;
        store
          .dispatch("api/apiRequest", fetchPrivilegeCopy)
          .then((response) => {
            actionTable.fetchPayload();
          })
          .catch((error) => {
            loading.tableData = false;
            openErrorModal(error);
          })
          .finally(() => {});
      }
    );
  };

  const deletePrivilege = (privilege) => {
    openWarningModal(
      "ลบ Privilege",
      `ต้องการลบ ${privilege.name_th} ใช่หรือไม่`,
      () => {
        loading.tableData = true;
        fetchPrivilegeDelete.payload.Privilege_Id = privilege.privilege_id;
        store
          .dispatch("api/apiRequest", fetchPrivilegeDelete)
          .then((response) => {
            actionTable.fetchPayload();
          })
          .catch((error) => {
            loading.tableData = false;
            openErrorModal(error);
          })
          .finally(() => {});
      }
    );
  };

  actionTable.fetchPayload = (showLoading = true) => {
    if (showLoading) {
      loading.tableData = true;
    }
    fetchPrivilegeListModel.payload.Page = pagination.currentPage;
    fetchPrivilegeListModel.payload.Limit = pagination.perPage;
    fetchPrivilegeListModel.payload.Filters = filters;
    fetchPrivilegeListModel.payload.Ordering = ordering.value;
    store
      .dispatch("api/apiRequest", fetchPrivilegeListModel)
      .then((response) => {
        privilegeTable.payload = response.data.payload;
        pagination.rows = response.data.payload.length;
        pagination.totalRows = response.data.filtered_record;
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        loading.tableData = false;
        loading.tableOverlay = false;
      });
  };

  const buildCategoryFromPayload = (category) => {
    const cateStr = category.map((o) => o.name_en);
    return cateStr.toString() || "-";
  };

  const onSelectAssignInventory = (inventory) => {
    window.$loading(true);
    fetchAssignEntryInventory.payload.Inventory_Id = inventory.inventory_id;
    fetchAssignEntryInventory.payload.Privilege_Id =
      privilegeSelect.value.privilege_id;
    store
      .dispatch("api/apiRequest", fetchAssignEntryInventory)
      .then((response) => {})
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        window.$loading(false);
        actionTable.fetchPayload(false);
      });
  };

  const setDefaultActiveTab = () => {
    localStorage.removeItem("activeTab");
  };

  const onClickAddData = () => {
    setDefaultActiveTab();
    router.push("/privilege/create");
  };

  onBeforeMount(() => {
    actionTable.fetchPayload();
  });

  return {
    formStatus,
    fields,
    loading,
    statusOption,
    privilegeTable,
    privilegeActionList,
    sortableRowOptions,
    keyChange,
    tableModeReorder,
    currentIndex,
    modalType,
    pagination,
    privilegeSelect,
    onSetValueSearch,
    onPageChange,
    onFilterEntity,
    resolveMappingTableAction,
    resolveStatusLabel,
    resolveStatusClass,
    reorderPrivilege,
    onClickReorder,
    reorderPrivilege,
    onCloseModalPrivilege,
    buildCategoryFromPayload,
    onSelectFilter,
    onSelectAssignInventory,
    onClickAddData,
    deletePrivilege,
    modalPopup,
    onOpenExportModal,
    closeReportModal,
    getPermissionModule
  };
}
